import script from './component-lib.esm3.js';
import normalizeComponent from '../../external/vue-runtime-helpers/dist/component-lib.esm.js';
import createInjector from '../../external/vue-runtime-helpers/dist/inject-style/component-lib.esm.js';

/* script */
const __vue_script__ = script;

/* template */
var __vue_render__ = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', _vm._b({
    staticClass: "chip-group",
    class: {
      'chip-group--scroll': _vm.scroll
    },
    attrs: {
      "role": "listbox",
      "aria-label": _vm.ariaLabel,
      "aria-labelledby": _vm.ariaLabelledby
    }
  }, 'div', _vm.$attrs, false), [_vm._t("default")], 2);
};
var __vue_staticRenderFns__ = [];

/* style */
const __vue_inject_styles__ = function (inject) {
  if (!inject) return;
  inject("data-v-3acc62b7_0", {
    source: ".chip-group[data-v-3acc62b7]{display:flex;flex-wrap:wrap;gap:.5rem}.chip-group--scroll[data-v-3acc62b7]{flex-wrap:unset;overflow-x:auto}",
    map: undefined,
    media: undefined
  });
};
/* scoped */
const __vue_scope_id__ = "data-v-3acc62b7";
/* module identifier */
const __vue_module_identifier__ = undefined;
/* functional template */
const __vue_is_functional_template__ = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__ = /*#__PURE__*/normalizeComponent({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__, __vue_module_identifier__, false, createInjector, undefined, undefined);
var ChipGroup = __vue_component__;
export { ChipGroup as default };